import { Page } from './types'

type DockerStartComputeServerProps = {
    license: string
}

const render = ({ license }: DockerStartComputeServerProps) => {
    const licenses: Record<string, string> = {
        'wlscs': 'WLS license file',
        'tsclient': 'Token Server client license file'
    }    
    return <>
    <p>
        You now know where to find the base image for Compute Server, you have
        a {licenses[license??'']} called <code>gurobi.lic</code> and
        optionally a custom <code>grb_rs.cnf</code> configuration file. That means
        you're ready to start the Compute Server container with the following command.        
    </p>
    <pre>
        docker run \<br/>
              --volume=$PWD/gurobi.lic:/opt/gurobi/gurobi.lic:ro \<br/>
              --volume=$PWD/grb_rs.cnf:/opt/gurobi_server/linux64/bin/grb_rs.cnf:ro \<br/>
              --hostname=localhost \<br/>
              -p61000:61000 \<br/>
              gurobi/compute
    </pre>
    <p>Notes:</p>
    <ul>            
        <li>If you don't need the <code>grb_rs.cnf</code> customization, you should leave out the corresponding line.</li>            
        <li>If you created a <code>grb_rs.cnf</code> from scratch, make sure to include the password definitions.</li>
        <li>The <code>-p61000:61000</code> port mapping ensures your Compute Server can be reached on port 61000 of the host machine.</li>
    </ul>
    </>
}

const DockerStartComputeServer : Page<DockerStartComputeServerProps> = { key: 'docker-start-compute-server', title: 'Start container with license', render }

export default DockerStartComputeServer